import { action } from 'mobx'

import AgencyResources from 'Services/AgencyResources'
import BaseStore from 'Stores/base_store/BaseStore'
import { getStoreFor } from 'Stores/StoreInstances'

export const STORE_TYPE = 'ExpenseCategories'

export function getExpenseCategoriesStoreFor (param, opts = {}) {
  return getStoreFor(ExpenseCategoriesStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}
class ExpenseCategoriesStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll () {
    let payload = {
      ...this._filter,
    }
    return AgencyResources.requestResources(payload)
        .then(resources => resources.expense_categories)
        .catch(console.error)
  }
}

export default ExpenseCategoriesStore
